import React, { useState } from "react";
import { X, Send } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function MessageComposer({ toUserId, toName, event, onClose }) {
  const { t, user } = useApp();
  const nav = useNavigate();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/messages/start", { to_user_id: toUserId, text, event_id: event?.event_id || null });
      toast.success(t("messageSent"));
      onClose(); nav(`/messages/${data.conversation_id}`);
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center p-0 sm:p-6" onClick={onClose} data-testid="message-composer">
      <div onClick={e => e.stopPropagation()} className="gg-card bg-background p-5 sm:p-6 w-full sm:max-w-md">
        <div className="flex items-center justify-between">
          <h3 className="font-display uppercase text-2xl">{t("messageTo", { name: toName })}</h3>
          <button onClick={onClose} className="gg-icon-btn" aria-label={t("cancel")} data-testid="composer-close"><X className="w-5 h-5" /></button>
        </div>
        {event && <div className="mt-2 text-sm" data-testid="composer-regarding"><span className="eyebrow !text-[10px] text-primary mr-2">{t("regarding")}:</span>{event.name}</div>}
        {!user && <p className="mt-3 text-sm text-muted-foreground">{t("signInPitch")}</p>}
        <textarea rows={5} maxLength={2000} className="gg-input mt-4" placeholder={t("messagePlaceholder")} value={text} onChange={e => setText(e.target.value)} disabled={!user} data-testid="composer-text" />
        <div className="mt-3 flex justify-end">
          <button onClick={send} disabled={busy || !user || !text.trim()} className="gg-btn-primary" data-testid="composer-send"><Send className="w-4 h-4" />{t("send")}</button>
        </div>
        <p className="mt-3 text-xs text-muted-foreground">{t("messagePrivacyNote")}</p>
      </div>
    </div>
  );
}
